import {
    IonBadge, IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon,
    IonInfiniteScroll, IonInfiniteScrollContent, IonInput, IonItem, IonLabel, IonList, IonModal, IonNote, IonPage, IonProgressBar, IonRow,
    IonSearchbar, IonTitle, IonToolbar,
    useIonLoading,
    useIonToast, useIonModal,
    IonThumbnail,
    IonAvatar,
    IonImg,
    IonSegmentButton,
    IonSegment,
    IonCard,
    IonFooter,
    IonItemDivider,
    IonRadioGroup,
    IonRadio
} from "@ionic/react";
import { cart, cartOutline, checkmark, chevronBackOutline, personCircle, 
    search, searchOutline, alertSharp, paperPlane, star, starOutline } from "ionicons/icons";
import { useEffect, useRef, useState, useContext, useLayoutEffect } from "react";

import axiosCall from '../data/axios';

import { format } from 'date-fns';
import { getCaptchaToken } from "../Helper";

const formatTimestamp = (timestamp: any) => {
    return format(new Date(timestamp), 'PPpp'); // PPpp gives a readable format like June 6, 2024 at 11:37 AM
};

const GiftCard = () => {

    const [buffer, setBuffer] = useState(0.06);

    const [progress, setProgress] = useState(0);

    const [giftCard, setGiftCard] = useState<any>([]);

    const [cardNo, setCardNo] = useState<any | null>('');
    const [code, setCode] = useState<any | null>('');

    const [spinnerPresent, spinnerDismiss] = useIonLoading();
    const [presentToast] = useIonToast();

    const fetchGiftCard = async (cardNo: any, code: any) => {

        if(!cardNo || cardNo.length < 10) {
            presentToast({
                message: 'Please enter a valid gift card number',
                icon: alertSharp,
                color: 'danger',
                buttons: [
                    {
                        text: 'Dismiss',
                        role: 'cancel'
                    }
                ]
            });
            return;
        }
        if(!code || code.length < 4) {
            presentToast({
                message: 'Please enter gift card code',
                icon: alertSharp,
                color: 'danger',
                buttons: [
                    {
                        text: 'Dismiss',
                        role: 'cancel'
                    }
                ]
            });
            return;
        }

        const filter = {
            cardNumber: cardNo,
            code: code,
            captchaData : {}
        };

        await getCaptchaToken('SIGNUP').then((token: any) => { // Here wait token generated
			if (token) {
				filter.captchaData = {
                    captchaToken: token,
				    captchaAction: 'SIGNUP'
                }
			}
		});

        setProgress(0);
        setBuffer(0.06);

        // Set progress to 25% when fetching starts
        setProgress(0.25);

        await axiosCall("/api/check-gift-card-balance", 'post', filter, true)
            .then((res) => {

                if (res.status !== 200) {
                    presentToast({
                        message: 'Unable to fetch gift card details',
                        icon: alertSharp,
                        color: 'danger',
                        buttons: [
                            {
                                text: 'Dismiss',
                                role: 'cancel'
                            }
                        ]
                    });
                    return;
                }
                if (res.data.status !== 1) {
                    presentToast({
                        message: res.data.message || 'Unable to fetch gift card details',
                        icon: alertSharp,
                        color: 'danger',
                        buttons: [
                            {
                                text: 'Dismiss',
                                role: 'cancel'
                            }
                        ]
                    });
                    return;
                }

                if (res.data.status === 1) {
                    setGiftCard(res.data.data);
                }

            })
            .catch((error) => {
                //setIserror(true);
                presentToast({
                    message: 'Unable to fetch gift card details',
                    icon: alertSharp,
                    color: 'danger',
                    buttons: [
                        {
                            text: 'Dismiss',
                            role: 'cancel'
                        }
                    ]
                });
            }).finally(() => {
                const interval = setInterval(() => {
                    setProgress((prevProgress) => prevProgress >= 1 ? 1 : prevProgress + 0.25);
                    setBuffer((prevBuffer) => prevBuffer >= 1 ? 1 : prevBuffer + 0.25);
                }, 100);

                // Clear interval when progress reaches 100%
                if (progress >= 1) {
                    clearInterval(interval);
                };
            }
        );
    };

    return (

        <IonPage id="orders-page">
            <IonHeader>
                <IonToolbar>

                </IonToolbar>
            </IonHeader>

            <IonContent className="page-content ion-padding ion-text-center">
                <IonToolbar>
                    <IonRow class="ion-justify-content-center">
                        <IonCol>
                            <IonLabel>Gift Card</IonLabel>
                        </IonCol>
                    </IonRow>
                </IonToolbar>

                <IonGrid className="ion-padding-top">
                    <IonRow>
                        <IonCol size='9' offset-md="1">
                            <IonRow>
                                <IonCol sizeMd="8" sizeSm="12" size="Xs" className="ion-padding">
                                    <IonInput onIonInput={e => setCardNo(e.target.value)} value={cardNo}
                                        labelPlacement="floating" fill="outline" label="Card Number" placeholder="Enter card number" />
                                </IonCol>
                                <IonCol sizeMd="4" sizeSm="12" sizeXs="12" className="ion-padding">
                                    <IonInput onIonInput={e => setCode(e.target.value)} value={code}
                                        labelPlacement="floating" fill="outline" label="Code" placeholder="Enter code" />
                                </IonCol>
                            </IonRow>
                        </IonCol>
                        <IonCol size='2' className="ion-align-self-center">
                            <IonButton color="drukre" onClick={() => fetchGiftCard(cardNo, code)}>
                                <IonIcon icon={search} />&nbsp;
                                <span className="ion-hide-md-down">Check</span>
                            </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size-md="10" offset-md="1">
                            <IonRow>
                                <IonCol>
                                    <IonProgressBar color='drukre' buffer={buffer} value={progress}></IonProgressBar>
                                </IonCol>
                            </IonRow>
                            <IonRow class="ion-justify-content-center ion-hide-md-down">
                                <IonCol>
                                    Gift Card Details
                                </IonCol>
                            </IonRow>
                            {giftCard.length === 0 ?
                                <IonRow>
                                    <IonCol>
                                        <IonCard>
                                            <IonRow>
                                                <IonCol>
                                                    <p>No Gift Card found</p>
                                                </IonCol>
                                            </IonRow>
                                        </IonCard>
                                    </IonCol>
                                </IonRow>
                                : 
                                <IonRow>
                                    <IonCol>
                                        <IonCard>
                                            <IonRow>
                                                <IonCol>
                                                    <p>Card Number: {giftCard.number}</p>
                                                    <p>Code: {giftCard.code}</p>
                                                    <p>Balance Amount: Nu. {giftCard.amount}</p>
                                                    <p>Status: {giftCard.status}</p>
                                                </IonCol>
                                            </IonRow>
                                        </IonCard>
                                    </IonCol>
                                </IonRow>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
}

export default GiftCard;